export const plausible: (event: string, props?: any) => void =
  (window as any).plausible ||
  function () {
    if (!(window as any)?.plausible) {
      (window as any).plausible = {
        q: [],
      };
    }

    ((window as any).plausible.q = (window as any).plausible.q || []).push(
      arguments,
    );
  };
